import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { StringParam, useQueryParam } from 'use-query-params'

import { ReactComponent as PlusCircle } from '../../../assets/icons/add-circle.svg'
import { useDebounce } from '../../../hooks/useDebounce'
import { useResponsesStore } from '../../../stores/responsesStore'
import { SearchBar } from '../../SearchBar/SearchBar'

import styles from './responses-head.module.scss'

function ResponsesHead() {
    const { t } = useTranslation()

    const [searchParam, setSearchParam] = useQueryParam('search', StringParam)

    const [, { switchIsKeyAdding, switchIsResponseAdding }] =
        useResponsesStore()

    const [searchInput, setSearchInput] = useState(searchParam || '')

    useDebounce(handleSetSearchParam, 300)(searchInput)

    function handleSetSearchParam(searchInput: string) {
        if (!searchInput || searchParam === searchInput) return

        setSearchParam(searchInput)
    }

    return (
        <header className={styles.responsesHead}>
            <div className={styles.responsesHead__row}>
                <h1 className={styles.responsesHead__title}>
                    {t('responses')}
                </h1>
            </div>
            <div className={styles.responsesHead__row}>
                <SearchBar value={searchInput} onChange={setSearchInput} />
            </div>
            <div className={styles.responsesHead__row}>
                <div className={styles.responsesHead__keySection}>
                    <p>{t('key')}</p>
                    <button
                        className={styles.responsesHead__btn}
                        onClick={switchIsKeyAdding}
                    >
                        <PlusCircle />
                        {t('add_new')}
                    </button>
                </div>
                <div className={styles.responsesHead__responsesSection}>
                    <p>{t('responses')}</p>
                    <button
                        className={styles.responsesHead__btn}
                        onClick={switchIsResponseAdding}
                    >
                        <PlusCircle />
                        {t('add_new')}
                    </button>
                </div>
            </div>
        </header>
    )
}

export default ResponsesHead
